export default __webpack_public_path__ + "static/board-healthscore-dd97818f5837cbd1f7e464aa803bf159.svg";